// src/components/TopBanner.js
import React from "react";
import { Link } from "react-router-dom";
import "../styles/CustomerSiteStyles/TopBanner.css";

const TopBanner = ({ onClose }) => {
  return (
    <div className="top-banner">
      <p>
        Get a FREE Home Inspection Today! {" "}
        <Link to="/contact">Contact Us!</Link>
      </p>
      <button className="close-button" onClick={onClose}>
        &times;
      </button>
    </div>
  );
};

export default TopBanner;